import * as React from 'react';

// Contexts
import { AuthContext } from '../contexts/Auth';

// Types
import { IUserRole } from '../types';

const userRoleRanks = {
    [IUserRole.CIC_OWNER]: 1,
    [IUserRole.CIC_ADMIN]: 2,
    [IUserRole.CIC_USER]: 3,
    [IUserRole.ORG_PRIMARY]: 4,
    [IUserRole.ORG_USER]: 5
};

const CIC_ROLES = [IUserRole.CIC_OWNER, IUserRole.CIC_ADMIN, IUserRole.CIC_USER];
const ORG_ROLES = [IUserRole.ORG_PRIMARY, IUserRole.ORG_USER];

export const useHighestUserRole = (roles?: IUserRole[], type?: 'cic' | 'org') => {
    const includedRoles = React.useMemo(() => {
        if (!type) return [...CIC_ROLES, ...ORG_ROLES];
        return type === 'cic' ? CIC_ROLES : ORG_ROLES;
    }, [type]);
    const highestUserRole = React.useMemo(() => {
        if (roles && roles?.length > 0) {
            const orderedRoles = roles
                .filter((role) => includedRoles.includes(role))
                .sort((a, b) => userRoleRanks[a] - userRoleRanks[b]);

            return orderedRoles[0];
        } else {
            return undefined;
        }
    }, [roles, includedRoles]);
    const getHighestRole = (rolesArg?: IUserRole[]) => {
        if (rolesArg && rolesArg?.length > 0) {
            const orderedRoles = rolesArg.sort((a, b) => userRoleRanks[a] - userRoleRanks[b]);

            return orderedRoles[0];
        } else {
            return undefined;
        }
    };

    return { highestUserRole, getHighestRole };
};

export default useHighestUserRole;
